// FE_i18n starling配置的语言
export var LANGUAGES_CLIENT = [
    'ar',
    'en',
    'es',
    'fr',
    'jv-ID',
    'ceb-PH',
    'af-ZA',
    'bn-IN',
    'cs-CZ',
    'de-DE',
    'el-GR',
    'fi-FI',
    'fil-PH',
    'gu-IN',
    'he-IL',
    'hi-IN',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ms-MY',
    'km-KH',
    'kn-IN',
    'ko-KR',
    'ml-IN',
    'mr-IN',
    'my-MM',
    'nl-NL',
    'or-IN',
    'pa-IN',
    'pl-PL',
    'pt-BR',
    'ro-RO',
    'ru-RU',
    'sv-SE',
    'ta-IN',
    'te-IN',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'vi-VN',
    'zu-ZA',
    'zh-Hant-TW',
    'sw',
    'ur',
];
export function formatLanguage(locale) {
    var langs = LANGUAGES_CLIENT;
    // 处理一些特殊 case，将国家简称映射为 starling 语言项
    var LANGUAGES_MAP = {
        in: 'id', // 印度尼西亚 -> 印尼语
    };
    if (!langs.includes(locale)) {
        if (locale in LANGUAGES_MAP) {
            locale = LANGUAGES_MAP[locale];
        }
        // 若 locale 为 xx-Xx-Xx，则提取为数组 [xx, xx-Xx, xx-Xx-Xx]，然后在 langs 中正则匹配得上其中之一的
        var locales_1 = locale.split('-');
        for (var i = 1; i < locales_1.length; i++) {
            locales_1[i] = locales_1[i - 1] + "-" + locales_1[i];
        }
        var result = langs.find(function (lang) { return locales_1.some(function (l) { return new RegExp(l, 'i').test(lang); }); });
        if (result) {
            return result;
        }
    }
    return locale;
}
